import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Loading from '../Loading/Loading';
import { EnvironmentService } from '../../services/Environment.service';

function RedirectUser(props) {
  const { user, invited } = props;
  const history = useHistory();
  const location = useLocation();
  const redirect = user => {


    const isReferee = user?.refereed_league_ids?.length > 0;

    if (user && user.is_leagues_manager === true) {
      history.push('/leagues');
    } else if (isReferee) {
      history.push('/leagues');
    } else if (user.player === null || user.player === undefined) {

      history.push('/signup/2');
    } else if (user.player?.status === 'needs_details_update') {
      // Redirect player to update-details screen
      history.push('/update-details');
    } else if (invited !== null) {
      history.push(`/leagues/${Number(invited.league)}/teams/${Number(invited.group)}/join`);
    } else {
      const url = `/cityleagues/${user.player.city}`;
      history.push(url);
    }
  };

  React.useEffect(() => {
    user && redirect(user);
  }, [user, location, invited, history]);

  return (<div>
      <Loading />
    </div>);
}

export default RedirectUser;
